export default __webpack_public_path__ + "static/media/background.66f79232.jpg";